/**
 * Toolbar Slider - Lightweight announcement rotator
 */

class ToolbarSlider {
  constructor(element) {
    this.element = element;
    this.swiper = null;
    
    // Parse options
    try {
      this.options = JSON.parse(element.dataset.swiperOptions || '{}');
    } catch (e) {
      console.error('[ToolbarSlider] Failed to parse options:', e);
      this.options = {};
    }
    
    // Wait for Swiper and init
    this.waitForSwiper();
  }

  waitForSwiper() {
    if (typeof Swiper !== 'undefined') {
      this.init();
    } else {
      setTimeout(() => this.waitForSwiper(), 100);
    }
  }

  init() {
    try {
      // Wrap direct children with swiper-slide class
      const wrapper = this.element.querySelector('.swiper-wrapper');
      if (wrapper) {
        Array.from(wrapper.children).forEach(child => {
          if (!child.classList.contains('swiper-slide')) {
            child.classList.add('swiper-slide');
          }
        });
      }

      // Initialize Swiper
      this.swiper = new Swiper(this.element, {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 600,
        fadeEffect: {
          crossFade: true
        },
        watchSlidesProgress: true,
        ...this.options, // Spread options AFTER defaults so they take precedence
        on: {
          init: () => {
            this.element.classList.add('swiper-initialized');
            this.removeDefaultArrowStyles();
          },
          ...(this.options.on || {}) // Merge any custom on callbacks
        }
      });
    } catch (e) {
      console.error('[ToolbarSlider] Init failed:', e);
    }
  }

  removeDefaultArrowStyles() {
    const prev = this.element.querySelector('.swiper-button-prev');
    const next = this.element.querySelector('.swiper-button-next');
    
    [prev, next].forEach(btn => {
      if (btn) {
        btn.style.backgroundImage = 'none';
      }
    });
  }

  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

// Auto-init
function initToolbarSliders() {
  document.querySelectorAll('[data-toolbar-slider]').forEach(slider => {
    if (!slider.dataset.toolbarInit) {
      slider.dataset.toolbarInit = 'true';
      new ToolbarSlider(slider);
    }
  });
}

// Init on load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initToolbarSliders);
} else {
  initToolbarSliders();
}

// Re-init on section load (theme editor)
document.addEventListener('shopify:section:load', () => {
  setTimeout(initToolbarSliders, 100);
});

window.ToolbarSlider = ToolbarSlider;
